import { debounce }         from 'lodash-es';
import { getElementOffset } from './_utils';

export default class AdfNav
{
    constructor ()
    {

        this.clickDown = null;

        this.isOpen            = false;
        this.desktopBreakpoint = 1200;
        this.currentBreakpoint = false;

        this.btnNavToggle      = document.querySelector( '#main-site-navigation-toggle' );
        this.navMenuContainer  = document.querySelector( '#main-site-navigation' );
        this.navMenuLinks      = Array.from( this.navMenuContainer.querySelectorAll( 'a' ) );
        this.navMenuLinksFirst = this.navMenuLinks[ 0 ];
        this.navMenuLinksLast  = this.navMenuLinks.slice( -1 )[ 0 ];

        this.submenuTogglers = this.navMenuContainer.querySelectorAll( '.submenu-toggler' );
        this.submenuLinks    = this.navMenuContainer.querySelectorAll( 'a.level_1' );

        // only need for mobile because of inverted order of
        // btnMenu and logo link on mobile vs desktop
        this.btnMainContentJumplink = document.querySelector( '#btn-jump-main-content' );
        this.btnMobileToggleSearch  = document.querySelector( '#nav-search-mobile-toggle' );
        this.logoLink               = document.querySelector( '#header-logo-link' );


        setTimeout( this.whereShouldIjumpTo, 5000 );

        this.bindMenuEventsEveryone();

        // this now takes care of binding, based on window size
        this.resetSizeChangeProperties();


    }

    //             _ _   __  __           _               _______ _
    //       /\   | | | |  \/  |         | |             / / ____(_)
    //      /  \  | | | | \  / | ___   __| | ___  ___   / / (___  _ _______  ___
    //     / /\ \ | | | | |\/| |/ _ \ / _` |/ _ \/ __| / / \___ \| |_  / _ \/ __|
    //    / ____ \| | | | |  | | (_) | (_| |  __/\__ \/ /  ____) | |/ /  __/\__ \
    //   /_/    \_\_|_| |_|  |_|\___/ \__,_|\___||___/_/  |_____/|_/___\___||___/
    //
    //


    bindMenuEventsEveryone ()
    {
        window.addEventListener( 'resize', debounce( () =>
        {
            this.resetSizeChangeProperties();
        }, 100 ) );

        document.addEventListener( 'keydown', this.handleMenuKeypressesEveryone.bind( this ) );

        this.btnNavToggle.addEventListener( 'click', this.toggleMenu.bind( this ) );
    }

    getBreakpointMode ()
    {
        return window.innerWidth < this.desktopBreakpoint ? 'mobile' : 'desktop';
    }


    isMobile ()
    {
        return this.currentBreakpoint === 'mobile';
    }

    resetSizeChangeProperties ()
    {

        const previousBreakpointMode = this.currentBreakpoint;

        this.currentBreakpoint = this.getBreakpointMode();

        if ( previousBreakpointMode === this.currentBreakpoint )
        {
            // no use in unnbinding, rebinding, etc..
            // ...when staying in the same breakpoint/size mdoe
            return;
        }



        if ( 'mobile' === this.currentBreakpoint )
        {
            this.unbindMenuEventsDesktop();
            this.unsetDesktopMenuProperties();

            this.setupMobileProperties();
            this.bindMenuEventsMobile();

        } else
        {
            this.undbindMenuEventsMobile();
            this.unsetMobileProperties();

            this.setupDesktopMenuProperties();
            this.bindMenuEventsDesktop()
        }

    }


    handleMenuKeypressesEveryone ( e )
    {

        // esc
        if ( e.which === 27 )
        {
            if ( this.isOpen )
            {
                this.closeMenu();
            }
        }


    }


    closeMenu ()
    {
        this.isOpen = false;
        this.navMenuContainer.classList.remove( 'animate__slideInDown' );
        this.navMenuContainer.classList.add( 'animate__slideOutUp' );
        this.navMenuContainer.setAttribute( 'aria-expanded', false );
        // this.navMenuContainer.setAttribute( 'hidden', true );

        // const allLinks = this.navMenuContainer.querySelectorAll( 'a' );
        // Array.from( allLinks ).forEach( el => el.removeAttribute( 'tabindex' ) );


        this.btnNavToggle.classList.remove( 'open' );
        this.btnNavToggle.setAttribute( 'aria-label', 'Ouvrir menu principal' );
        // this.btnNavToggle.removeAttribute( 'tabindex' );

        this.btnNavToggle.focus();

        // otherwise, display: none and no transition
        setTimeout( () =>
        {
            this.navMenuContainer.classList.remove( 'open', 'animate__slideInDown' );
        }, 500 )

        this.resetMenu();
    }


    toggleMenu ()
    {
        if ( this.isOpen )
        {
            this.closeMenu();
        } else
        {
            this.openMenu();
        }
    }

    openMenu ()
    {
        this.isOpen = true;
        this.navMenuContainer.classList.remove( 'animate__slideOutUp' );
        this.navMenuContainer.classList.add( 'open', 'animate__animated', 'animate__slideInDown' );
        this.navMenuContainer.setAttribute( 'aria-expanded', true );
        // this.navMenuContainer.removeAttribute( 'hidden' );

        // let firstLink;
        // if ( this.isMobile() )
        // {
        //     firstLink = this.navMenuContainer.querySelector( '.nav-menu.level_0 .submenu-toggler' );
        // } else
        // {
        //     firstLink = this.navMenuContainer.querySelector( 'a' );
        // }


        // const allLinks = this.navMenuContainer.querySelectorAll( 'a' );
        // Array.from( allLinks ).forEach( el => el.setAttribute( 'tabindex', 1 ) );

        this.btnNavToggle.setAttribute( 'aria-label', 'Fermer menu principal' );
        // this.btnNavToggle.setAttribute( 'tabindex', 1 );
        this.btnNavToggle.classList.add( 'open' );
        this.btnNavToggle.focus();
    }


    resetMenu ()
    {
        Array.from(
            this.navMenuContainer.querySelectorAll( '.open' ),
        )
            .forEach( ( el, i ) =>
            {
                el.classList.remove( 'open' );
            } )
    }

    //    _____            _    _
    //   |  __ \          | |  | |
    //   | |  | | ___  ___| | _| |_ ___  _ __
    //   | |  | |/ _ \/ __| |/ / __/ _ \| '_ \
    //   | |__| |  __/\__ \   <| || (_) | |_) |
    //   |_____/ \___||___/_|\_\\__\___/| .__/
    //                                  | |
    //                                  |_|

    bindMenuEventsDesktop ()
    {

        this.boundMenuEventsDesktopKeydown = this.handleKeypressesDesktop.bind( this )

        document.addEventListener( 'keydown', this.boundMenuEventsDesktopKeydown );


    }

    unbindMenuEventsDesktop ()
    {
        document.removeEventListener( 'keydown', this.boundMenuEventsDesktopKeydown );
    }

    setupDesktopMenuProperties ()
    {

    }

    unsetDesktopMenuProperties ()
    {

    }

    handleKeypressesDesktop ( e )
    {
/*console.log(( e.code, e.key, e.shift, e.target, e.target === this.btnMainContentJumplink ))*/;

        const isSpaceOrEnter = [ ' ', 'Enter' ].indexOf( e.key ) > -1;


        // shift-tab
        if ( this.isOpen && e.which === 9 && e.shiftKey )
        {
            if ( e.target === this.navMenuLinksFirst )
            {
                e.preventDefault();
                this.btnNavToggle.focus();
            } else if ( e.target === this.btnNavToggle )
            {
                e.preventDefault();
                this.navMenuLinksLast.focus();
            }

        }
        // tab
        else if ( this.isOpen && e.which === 9 && !e.shiftKey )
        {
            if ( e.target === this.navMenuLinksLast )
            {
                e.preventDefault();
                this.btnNavToggle.focus();
            } else if ( e.target === this.btnNavToggle )
            {
                e.preventDefault();
                this.navMenuLinksFirst.focus();
            }
        }

        // space + enter
        else if ( isSpaceOrEnter )
        {
            if ( e.target === this.btnMainContentJumplink )
            {


                let firstHeading = this.whereShouldIjumpTo();

                e.preventDefault();

                document.activeElement.blur();

                if ( firstHeading )
                {

                    let anchorLink = document.createElement( 'a' );
                    anchorLink.setAttribute( 'name', 'first-link' );
                    anchorLink.setAttribute( 'href', '#' );
                    anchorLink.classList.add( 'focusabled-anchor' );
                    firstHeading.prepend( anchorLink );


                    window.scrollTo( {
                        top      : getElementOffset( anchorLink ).top - 90,
                        left     : 0,
                        behavior : 'smooth',
                    } );


                    anchorLink.focus( { focusVisible : true } );

                }

            }
        }
    }


    whereShouldIjumpTo ()
    {
        let firstHeading = document.querySelector( 'h1' );

        if ( !firstHeading )
        {
            firstHeading = document.querySelector( 'section' );
        }

        if ( !firstHeading )
        {
            firstHeading = document.querySelector( 'h2' );
        }

/*console.log(( '%c[ Sauter au contenu ]', 'background: #e325d3; color: #25e32e; padding: 5px;', ' Si je voulais sauter au contenu, je crois que je voudrais sauter à : ' , firstHeading ))*/;        return firstHeading;
    }

    //    __  __       _     _ _
    //   |  \/  |     | |   (_) |
    //   | \  / | ___ | |__  _| | ___
    //   | |\/| |/ _ \| '_ \| | |/ _ \
    //   | |  | | (_) | |_) | | |  __/
    //   |_|  |_|\___/|_.__/|_|_|\___|
    //
    //

    bindMenuEventsMobile ()
    {
        this.boundMenuEventsMobileClick = this.toggleSubmenu.bind( this );

        Array.from( this.submenuTogglers ).forEach( ( el, i ) =>
        {
            el.addEventListener( 'click', this.boundMenuEventsMobileClick );
        } );


        this.boundMenuEventsMobileKeypresses = this.handleKeypressesMobile.bind( this )
        document.addEventListener( 'keydown', this.boundMenuEventsMobileKeypresses );
    }

    undbindMenuEventsMobile ()
    {
        Array.from( this.submenuTogglers ).forEach( ( el, i ) =>
        {
            el.removeEventListener( 'click', this.boundMenuEventsMobileClick );
        } );

        document.removeEventListener( 'keydown', this.boundMenuEventsMobileKeypresses );

    }


    toggleSubmenu ( event )
    {


        const clicked  = event.target,
              parentLi = clicked.closest( 'li' );

        if ( parentLi.classList.contains( 'open' ) )
        {
            this.closeSubmenu( parentLi, clicked );
        } else
        {
            this.openSubmenu( parentLi, clicked );
        }

    }

    openSubmenu ( parentLi, clicked )
    {
        parentLi.classList.add( 'open' );

        const childAnchors = parentLi.querySelectorAll( 'a' );

        if ( !childAnchors )
        {
            return;
        }

        Array.from( childAnchors ).forEach( ( el, i ) =>
        {
            el.setAttribute( 'tabindex', 0 );
        } );


        clicked.setAttribute( 'aria-expanded', true );

    }

    closeSubmenu ( parentLi, clicked )
    {
        parentLi.classList.remove( 'open' );


        // close all the children, as well
        const allChildrenLinks = parentLi.querySelectorAll( '.nav-menu a' );

        Array.from( allChildrenLinks ).forEach( ( el, i ) =>
        {
            el.setAttribute( 'tabindex', -1 );
        } );


        clicked.setAttribute( 'aria-expanded', false );

    }


    setupMobileProperties ()
    {

        Array.from( this.submenuTogglers ).forEach( ( el, i ) =>
        {

            // https://developer.mozilla.org/en-US/docs/Web/CSS/:scope
            const parentLi       = el.closest( 'li' );
            const submenuGroup   = parentLi.querySelector( ':scope > .nav-menu' );
            const submenuGroupId = submenuGroup ? submenuGroup.getAttribute( 'id' ) : '';


            el.setAttribute( 'tabindex', 0 );
            el.setAttribute( 'aria-expanded', false );
            el.setAttribute( 'aria-controls', submenuGroupId );


        } );

        Array.from( this.submenuLinks ).forEach( ( el, i ) =>
        {
            el.setAttribute( 'tabindex', -1 );
        } );
    }

    unsetMobileProperties ()
    {


        const unsetTabIndexArray = Array.from( this.submenuTogglers )
            .concat( Array.from( this.submenuLinks ) );

        unsetTabIndexArray.forEach( ( el, i ) =>
        {
            el.setAttribute( 'tabindex', 0 );
        } );


    }

    handleKeypressesMobile ( e )
    {
        // console.log( e.code, e.key, e.shift, e.target, e.target === this.navMenuLinksFirst, e.target === this.navMenuLinksLast );


        const isRegularTab = e.which === 9 && !e.shiftKey;
        const isShiftTab   = e.which === 9 && e.shiftKey;

        if ( this.isOpen )
        {


            // shift-tab
            if ( isShiftTab )
            {
                if ( e.target === this.logoLink )
                {
                    e.preventDefault();
                    this.btnNavToggle.focus();
                } else if ( e.target === this.btnNavToggle )
                {
                    e.preventDefault();
                    this.navMenuLinksLast.focus();
                } else
                {

                    const firstFoundLink = document.querySelector( '#main-site-navigation [tabindex="0"]' );

                    if ( firstFoundLink === e.target )
                    {


                        e.preventDefault();
                        console.log( 'it is me', e )
                        this.btnNavToggle.focus();
                    }
                }

            }
            // tab
            else if ( isRegularTab )
            {
                if ( e.target === this.navMenuLinksLast || e.target === this.btnNavToggle )
                {

                    e.preventDefault();

                    const firstFoundLink = document.querySelector( '#main-site-navigation [tabindex="0"]' );
                    firstFoundLink.focus();
                }
            }

        } else
        {
            // shift-tab
            if ( isShiftTab )
            {
                if ( e.target === this.btnNavToggle )
                {
                    e.preventDefault();
                    this.btnMainContentJumplink.focus();
                } else if ( e.target === this.logoLink )
                {
                    e.preventDefault();
                    this.btnNavToggle.focus();

                } else if ( e.target === this.btnMobileToggleSearch )
                {
                    e.preventDefault();
                    this.logoLink.focus();
                }

            }
            // tab
            else if ( isRegularTab )
            {
                if ( e.target === this.btnMainContentJumplink )
                {
                    e.preventDefault();
                    this.btnNavToggle.focus();
                } else if ( e.target === this.btnNavToggle )
                {
                    e.preventDefault();
                    this.logoLink.focus();
                } else if ( e.target === this.logoLink )
                {
                    e.preventDefault();
                    this.btnMobileToggleSearch.focus();
                }
            }
        }
    }

}

